import Image from "@/components/AppImage";
import what_in_it_icon_1 from "/public/img/what-in-it-icon-1.png";
import what_in_it_icon_2 from "/public/img/what-in-it-icon-2.png";
import what_in_it_icon_3 from "/public/img/what-in-it-icon-3.png";

const Whatinit = () => {
  return (
    <section className="whatinit-section">
      <div className="overlay pt-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-header text-center">
                <h3 className="title">WHAT’S IN IT FOR YOU?</h3>
                <p>Finish setup fast and keep every future payout on autopilot.</p>
              </div>
            </div>
          </div>
          <div className="bottom-content pb-120">
            <div className="row cus-mar">
              <div className="col-lg-4">
                <div className="single-item text-center">
                  <div className="icon">
                    <div className="iconbg">
                      <Image src={what_in_it_icon_1} alt="icon" />
                    </div>
                  </div>
                  <div className="bottom-area text-center">
                    <h5>Invoice any client.</h5>
                    <p>
                      Share a secure OracleMarket link—no awkward wire instructions
                      over email.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="single-item text-center">
                  <div className="icon">
                    <div className="iconbg">
                      <Image src={what_in_it_icon_2} alt="icon" />
                    </div>
                  </div>
                  <div className="bottom-area text-center">
                    <h5>Clients pay their way</h5>
                    <p>
                      Cards, bank transfers, and local methods—all routed into
                      your OracleMarket balance.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="single-item text-center">
                  <div className="icon">
                    <div className="iconbg">
                      <Image src={what_in_it_icon_3} alt="icon" />
                    </div>
                  </div>
                  <div className="bottom-area text-center">
                    <h5>Automated reminders</h5>
                    <p>
                      Nudge overdue invoices without chasing manually—we handle
                      the follow-ups.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Whatinit;
